import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, EmptyState, fmtDate, TYPE_META } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Trash2 } from "@/lib/icons";

export default function Trash() {
  const [caps, setCaps] = useState([]);
  const load = () => api.get("/trash").then((r) => setCaps(r.data.captures)).catch(() => {});
  useEffect(() => { load(); }, []);

  const restore = async (id) => { await api.post(`/captures/${id}/restore`); toast.success("Restored with links and original intact"); load(); };
  const purge = async (id) => {
    if (!window.confirm("Permanently delete this capture? This cannot be undone.")) return;
    await api.delete(`/trash/${id}/purge`); toast.success("Permanently deleted"); load();
  };

  return (
    <div className="max-w-3xl mx-auto">
      <PageHeader eyebrow="Settings" color="#64748B" title="Trash" subtitle="Soft-deleted captures. Restore them or purge permanently." />
      {caps.length === 0 ? <EmptyState icon={Trash2} title="Trash is empty" hint="Deleted captures land here before permanent removal." /> : (
        <div className="space-y-3">
          {caps.map((c) => {
            const meta = TYPE_META[c.type] || TYPE_META.note;
            return (
              <div key={c.id} className="dl-card p-4 flex items-center gap-3" data-testid={`trash-row-${c.id}`}>
                <meta.icon size={18} style={{ color: meta.color }} />
                <div className="flex-1 min-w-0"><div className="text-sm text-white truncate">{c.title || "Untitled"}</div><div className="text-[11px] text-slate-500">deleted {fmtDate(c.deleted_at)}</div></div>
                <Button size="sm" variant="outline" onClick={() => restore(c.id)} data-testid={`restore-${c.id}`}>Restore</Button>
                <Button size="sm" variant="ghost" onClick={() => purge(c.id)} className="text-red-400" data-testid={`purge-${c.id}`}>Delete</Button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
